import React from 'react'

import {
  Body2,
  BorderStyle,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading2,
  JustifyContent,
  Space,
  Stars,
  TextAlign,
} from '@gousto-internal/citrus-react'

import type { TestimonialsFields } from './types'

export type TestimonialsProps = TestimonialsFields

type TestimonialItem = TestimonialsFields['testimonials'][number]

const TestimonialCard = ({ quote, author }: TestimonialItem) => (
  <Box
    paddingV={6}
    paddingH={6}
    borderWidth={0.5}
    borderRadius={1.5}
    borderStyle={BorderStyle.Solid}
    borderColor={Color.ColdGrey_100}
  >
    <Box display={Display.Flex} justifyContent={JustifyContent.FlexStart} paddingBottom={4}>
      <Stars rating={5} />
    </Box>

    <Body2 size={4}>{quote}</Body2>
    <Space size={3} />
    <Body2 size={4}>{author}</Body2>
  </Box>
)

export function Testimonials({ heading, testimonials }: TestimonialsProps) {
  return (
    <Box paddingH={[8, 20]} paddingV={16} bg={Color.NeutralGrey_50}>
      <Box paddingBottom={6}>
        <Heading2 textAlign={[TextAlign.Left, null, null, TextAlign.Center]}>{heading}</Heading2>
      </Box>

      <Box
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, null, null, FlexDirection.Row]}
        justifyContent={[JustifyContent.SpaceEvenly, JustifyContent.Center]}
        gap={[6, 8]}
      >
        {testimonials.map((testimonial, index) => (
          <TestimonialCard
            key={`${testimonial.author}-${index}`}
            quote={testimonial.quote}
            author={testimonial.author}
          />
        ))}
      </Box>
    </Box>
  )
}
